module.exports = __webpack_public_path__ + "media/images/prismic_catalog/presentation_cards/subcategories/massage-a947e841b6f5ac15defbf80d2811efc2.png";